import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const EMPLOYEE_POST_SIGNIN = 'EMPLOYEE/POST_SIGNIN'

const apiCall = enhancedMakeFetchAction(EMPLOYEE_POST_SIGNIN, payload => ({
  endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/users/signin`,
  method: 'POST',
  body: payload,
  isStay: true
}))

export default apiCall
